'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('text-answer-edit', {
		props: ['answer', 'initData'],
		template:
		'<div>' +
            '<div class="fg-line mb-3">' +
                '<label for="name">{{initData.translations.answer}}</label>' +
                '<input type="text" class="form-control" v-model="answer.content" :placeholder="initData.translations.textAnswerPlaceholder" />' +
                '<small>{{initData.translations.textAnswerHint}}</small>' +
            '</div>' +
		'</div>',
	});
});
